import Vue from '../../../lib/utils/vue'
import { styled, VueEmotion } from '@egoist/vue-emotion'

import CvtButton from '../../molecules/Button'
import CvtSelect from '../../molecules/Select'
import { LazyImage } from '../../molecules/LazyImage'
import { ContentPlaceholder } from '../../molecules/ContentPlaceholder'
import * as getters from '../../../../builder/src/js/store/modules/getters'
import { mapGetters, mapState } from '../../../../builder/node_modules/vuex'
import { LEFT_SIDEBAR_STANDARD, LEFT_SIDEBAR_FRESHWORKS } from '../../constants'
import VueI18n from 'vue-i18n'
import CvtHeading from './heading'

Vue.use(VueEmotion)
Vue.use(VueI18n)

let Spacing, Radii, Border, AddPagesToRight

let borderColor, backgroundColor, textFontSize, textLineHeight, elevation, color

const getExpandedPages = () => styled('div')`
  display: grid;
  grid-template-rows: auto auto 1fr;
  grid-gap: ${Spacing.SPACING_24}px;
  padding: ${Spacing.SPACING_24}px ${Spacing.SPACING_8}px;
  border-left: ${Border.SIZE_1}px solid;

  ${(props) =>
    props.type === LEFT_SIDEBAR_FRESHWORKS
      ? `
      position: fixed;
      top: 100px;
      right: 64px;
      background-color: #FFF;
      height: 100vh;
  `
      : ``}

  ${(props) =>
    props.mode == 'DARK'
      ? borderColor({ themeing: 'dark' }, 500)
      : borderColor({ themeing: 'dark' }, 100)};
`

const getPage = () => styled('div')`
  display: flex;
  cursor: pointer;
  flex-direction: column;
  width: 300px;
  margin-bottom: ${Spacing.SPACING_24}px;

  &:last-child {
    margin-bottom: 0;
  }
`

const getPageName = () => styled('span')`
  margin-bottom: ${Spacing.SPACING_4}px;
  ${textFontSize('sm')}
  ${textLineHeight('xl')}
`

const getPageThumbnailWrapper = () => styled('div')`
  position: relative;
  overflow: hidden;
  border-radius: ${Radii.RADIUS_PX_8}px;
  ${(props) => elevation(props, 100)}

  &:hover {
    ${(props) => elevation(props, 400)}
    .overlay {
      display: flex;
    }
  }
`
const getPageOverlay = () => styled('div')`
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  justify-content: center;
  align-items: center;
  z-index: 1;
  ${backgroundColor({ themeing: 'dark' }, 100)}
  ${(props) =>
    props.mode == 'LIGHT'
      ? 'background: rgba(240, 242, 246, 0.5);'
      : 'background: rgb(73, 76, 83, 0.5);'}
  border-radius: ${Radii.RADIUS_PX_8}px;
`
const getPagesWrapper = () => styled('div')`
  overflow: auto;
  padding: 0 ${Spacing.SPACING_12}px;
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: ${Radii.RADIUS_PX_8}px;
    ${(props) =>
    props.mode == 'DARK'
      ? backgroundColor({ themeing: 'dark' }, 600)
      : backgroundColor({ themeing: 'dark' }, 100)}
  }

  ${(props) =>
    props.type === LEFT_SIDEBAR_FRESHWORKS
      ? `height: calc(100vh - 230px);`
      : ``}
`
const getAddBlankPageWrapper = () => styled('div')`
  padding: 0 ${Spacing.SPACING_12}px;
`
const getPlaceholderWrapper = () => styled('div')`
  position: relative;
  width: 300px;
  padding-top: calc((100% * 190 / 300) + 16px);
  margin-bottom: ${Spacing.SPACING_16}px;
`
const getPlaceholder = () => styled(ContentPlaceholder)`
  border-radius: ${Radii.RADIUS_PX_8}px;

  &.header-left {
    top: 0;
    left: 0;
    width: 70%;
    height: 16px;
    margin-bottom: ${Spacing.SPACING_8}px;
  }

  &.thumb-card {
    left: 0;
    width: 100%;
    height: calc(100% - 24px);
    top: 24px;
  }
`
const getBlankText = () => styled('span')`
  display: flex;
  width: 300px;
  justify-content: center;
`
const getSectionFilterWrapper = () => styled('div')`
  padding: 0 ${Spacing.SPACING_12}px;
  ${props => props.side === true ? `
    border-top: 1px solid #CFD7DF;
    box-shadow: 0px 8px 4px rgb(7 126 214 / 6%);
    padding-top: 24px;
  ` : ``}
`
const getSectionFilter = () => styled(CvtSelect)`
  ${color({ themeing: 'dark' }, 500)}
`

const getTitleWrapper = () => styled('div')`
 display:flex;
`
const getManagePageTitle = () => styled('div')`
  margin-top:auto; 
  margin-bottom:auto;
`
export const CvtSavePages = {
  name: 'CvtSavePages',
  data () {
    return {}
  },
  computed: {
    ...mapGetters('globalTheme', {
      textColor: getters.GLOBAL_STYLE_COLOR,
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      borderColor: getters.GLOBAL_STYLE_BORDER_COLOR,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
      textLineHeight: getters.GLOBAL_STYLE_LINE_HEIGHT,
      elevation: getters.GLOBAL_STYLE_ELEVATION
    }),
    ...mapState('globalTheme', {
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      Radii: ({ globalTheme }) => globalTheme.Radii,
      Border: ({ globalTheme }) => globalTheme.Border,
      AddPagesToRight: ({ globalTheme }) => globalTheme.AddPagesToRight !== undefined ? globalTheme.AddPagesToRight : false,
      PageGalleryLabel: ({ globalTheme }) => globalTheme.PageGalleryLabel !== undefined ? globalTheme.PageGalleryLabel : 'editor.section.filter.dropdown.placeholder',
      iconConfig: ({ iconConfig }) => iconConfig
    })
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT'
    },
    loading: {
      type: Boolean,
      default: true
    },
    pages: {
      type: Array,
      default: () => []
    },
    pageTags: {
      type: Array,
      default: () => ['ALL']
    },
    activeTag: {
      type: String,
      default: 'ALL'
    },
    type: {
      type: String,
      default: LEFT_SIDEBAR_STANDARD
    }
  },
  created () {
    Spacing = this.Spacing
    Radii = this.Radii
    Border = this.Border
    AddPagesToRight = this.AddPagesToRight
    borderColor = this.borderColor
    backgroundColor = this.backgroundColor
    textFontSize = this.textFontSize
    textLineHeight = this.textLineHeight
    elevation = this.elevation
    color = this.textColor
  },
  render: function (h) {
    const ExpandedPages = getExpandedPages()
    const pages = []
    const Page = getPage()
    const PageName = getPageName()
    const PageThumbnailWrapper = getPageThumbnailWrapper()
    const PageOverlay = getPageOverlay()
    const PagesWrapper = getPagesWrapper()
    const AddBlankPageWrapper = getAddBlankPageWrapper()
    const PlaceholderWrapper = getPlaceholderWrapper()
    const Placeholder = getPlaceholder()
    const BlankText = getBlankText()
    const SectionFilterWrapper = getSectionFilterWrapper()
    const SectionFilter = getSectionFilter()
    const TitleWrapper = getTitleWrapper()
    const ManagePageTitle = getManagePageTitle()
    const blankText = <BlankText>No Saved Pages found!</BlankText>
    const placeholders = Array(3).fill(
      <PlaceholderWrapper>
        <Placeholder class='header-left' mode={this.mode}></Placeholder>
        <Placeholder class='thumb-card' mode={this.mode}></Placeholder>
      </PlaceholderWrapper>
    )
    this.pages.forEach(page => {
      pages.push(
        <Page id={page.pageName}>
          <PageName>{page.pageName}</PageName>
          <PageThumbnailWrapper mode={this.mode}>
            <PageOverlay mode={this.mode} class={'overlay'}>
              <CvtButton
                color={this.type === LEFT_SIDEBAR_FRESHWORKS ? 'light' : ''}
                mode={this.mode}
                shadow={true}
                text='Add this Page'
                onClick={() => this.$emit('insert-page', page)}
              ></CvtButton>
            </PageOverlay>
            <LazyImage
              mode={this.mode}
              dataSrc={page.pageThumbnail}
            ></LazyImage>
          </PageThumbnailWrapper>
        </Page>
      )
    });
    return (
      <div>
        <ExpandedPages mode={this.mode} type={this.type}>
          <TitleWrapper>
            <CvtButton
              mode={this.mode}
              size={`md`}
              onClick={() => this.$emit('back')}
              icon={'fas fa-arrow-left'}
              actionIcon={true}
              removeBackground={true}
            ></CvtButton>
            <ManagePageTitle>
              {this.$t('editor.left_nav.manage_pages_title')}
            </ManagePageTitle>
          </TitleWrapper>
          <AddBlankPageWrapper>
            <CvtButton
              mode={this.mode}
              color={this.mode.toLowerCase()}
              size={this.type === LEFT_SIDEBAR_FRESHWORKS ? `sm` : ``}
              fullWidth={this.type === LEFT_SIDEBAR_STANDARD ? true : false}
              shadow={true}
              text={this.$t('editor.left_nav.add_a_blank_page_button_text')}
              onClick={() => this.$emit('insert-blank-page')}
              outlined={true}
              icon={ this.iconConfig.leftSidebar.pages.plus || '' }
            ></CvtButton>
          </AddBlankPageWrapper>
          <SectionFilterWrapper side={this.AddSectionsToRight}>
            {this.type === LEFT_SIDEBAR_FRESHWORKS && (
              <h5>{this.$t('editor.header.marketplace.title')}</h5>
            )}
            {this.pages.length > 0 && (
              <SectionFilter
                label={this.$t(this.SectionGalleryLabel)}
                floatingLabel={
                  this.type === LEFT_SIDEBAR_STANDARD ? true : false
                }
                mode="dropdown"
                backgroundMode={this.mode}
                showCancelIcon={false}
                value={this.activeTag}
                defaultValue={this.activeTag}
                onInput={(value) => {
                  this.$emit('filter-section', value)
                }}
              >
                {this.pageTags.map((option) => {
                  return <option value={option}>{option}</option>
                })}
              </SectionFilter>
            )}
          </SectionFilterWrapper>
          <PagesWrapper mode={this.mode} type={this.type}>
            {this.loading && placeholders} {!this.loading && (pages.length > 0 ? pages : blankText)}
          </PagesWrapper>
        </ExpandedPages>
      </div>
    )
  }
}
